import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=31c18e04"
import script from "./OverviewView.vue?vue&type=script&lang=js"
export * from "./OverviewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e7c46a58a2b84365ed6c46ff010356d5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports